const TAG_NAME = 'shopify-planner-helper';

if (!window.customElements.get(TAG_NAME)) {
  class ShopifyPlannerHelper extends HTMLElement {
    constructor() {
      super();
      this._setupListeners();
      this._init();
    }

    _init() {
      let baseUrl = 'https://konfigurator.nydo-studio.ch/ch';

      const path = window.location.pathname.toLowerCase();

      if (path.startsWith('/fr')) {
        baseUrl = 'https://konfigurator.nydo-studio.ch/ch-fr';
      } else if (path.startsWith('/en')) {
        baseUrl = 'https://konfigurator.nydo-studio.ch/ch-en';
      }

      const frameUrl = new URL(baseUrl);

      // pass query params if exist
      const searchParams = new URL(window.location).searchParams;
      const config = searchParams.get('config');
      const family = searchParams.get('family');

      if (config) frameUrl.searchParams.append('config', config);
      if (family) frameUrl.searchParams.append('family', family);

      frameUrl.searchParams.append('iframe', '1');

      this._setFrameUrl(frameUrl.toString());
    }

    _setFrameUrl(url) {
      const frame = this.querySelector('iframe');
      if (frame) frame.src = url;
    }

    _setupListeners() {
      window.addEventListener('message', this._onMessageEvent.bind(this));
    }

    _onMessageEvent(event) {
      if (!event.data?.type) return;

      if (event.data.type === 'cart:submit') {
        this._onCartSubmit(event);
      }
    }

    async _onCartSubmit(event) {
      try {
        const items = event.data.detail.items.map(item =>
          this._toIdQtySet(item, event.data.detail.configuration)
        );

        await this._addToCart(items);
      } catch (error) {
        console.error('[Planner] Add to cart failed:', error);
        alert(error.message);
        return;
      }

      // Must bubble so the cart drawer listener on `document` receives it
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        composed: true,
        detail: { baseEvent: 'variant:add', open: true }
      }));

      document.querySelector('cart-drawer')?.show();

      // PubSub: updates <cart-count> immediately (even if drawer is closed)
      const cart = await fetch(`${FoxTheme.routes.cart_url}.js`, { credentials: 'same-origin' }).then(r => r.json());
      if (cart) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: 'cart-submit',
          cart
        });
      }
    }

    _getLocaleAwareUrlRoot(path = '') {
      return (window?.Shopify?.routes?.root || '/') + path;
    }

    async _addToCart(items) {
      const response = await fetch(this._getLocaleAwareUrlRoot('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();

      // Shopify returns 422 with { description } e.g. variant not available in this market / sold out
      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add items to cart');
      }

      return data;
    }

    _toIdQtySet(item, configuration) {
      if (!item.variant_id) {
        throw new Error('variant_id not found: Planner is most likely not using ShopifyCheckout or a product is missing a variant_id.');
      }

      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: {
          _planner_code: configuration.code // IMPORTANT FOR ORDER CONVERSION TRACKING
        }
      };
    }
  }

  window.customElements.define(TAG_NAME, ShopifyPlannerHelper);
}
